import React, { useEffect, useState, useRef, useCallback } from "react";
import { io } from 'socket.io-client';
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Link } from "react-router-dom";
import { Dropdown, Row, Col, Nav, Form, Modal, Button } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import Avatar from "../components/Avatar";
import moment from 'moment';
import ringSound from '../../src/assets/ring.mp3';

import { patientname,generateMediaRoomId, 
  parseAvatar, } from "../utils/chat/utils";

  import { 
    markMessageAsRead,
    connectMediaSocket, 
    disconnectMediaSocket,
    getRecentMediaChats,
    getChatHistoryByPatient,
    sendMediaMessage,subscribeMediaIO,
    getMediaSocket, 
    Register} from "../utils/chat/telemedicineSockets";
import useProfileStore from "../store/patient/profileStore";
import { from } from "rxjs";
import CallScreen from "./chatComponents/CallScreen";

const ChatGlobal = () => {
  const { profile } = useProfileStore();
  const bottomRef = useRef(null);
  // const callStartTime = useRef(null);
  const ringingAudioRef = useRef(null);
  const userInteractedRef = useRef(false);

  const [callStartTime, setCallStartTime] = useState(null);
  const [activeUser, setActiveUser] = useState(null);
  const [showChat, setShowChat] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [callStatus, setCallStatus] = useState("");
  const [messages, setMessages] = useState([]);
  const [recentChats, setRecentChats] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [loadingMessages, setLoadingMessages] = useState(false);
  const [messageInput, setMessageInput] = useState("");
  const [callRequestData, setCallRequestData] = useState(null);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [showCallRequestModal, setShowCallRequestModal] = useState(false);

  

  const token = localStorage.getItem('token')
  // Initialize socket connection
  const user =  JSON.stringify(profile?.id)
  useEffect(() => {
    if (profile?.id) {
      connectMediaSocket(user, token);
      fetchRecentChats();
      subscribeMediaIO(handleCallRequest, handleCallCancelled);
      Register({ userId: JSON.stringify(profile?.id) });
      
      // Add message listener
      const socket = getMediaSocket();
      if (socket) {
        socket.on('private-message', handleIncomingMessage);
      }
      
      return () => {
        disconnectMediaSocket();
        if (socket) {
          socket.off('private-message', handleIncomingMessage);
        }
      };
    }
  }, [profile]);

  // Fetch recent chats
  const fetchRecentChats = () => {
    if (!profile?.id) return;
    
    getRecentMediaChats({ doctorId: user, token }, (chats) => {
      setRecentChats(chats.map(chat => ({
        id: chat.doctorId,
        patient: chat.patient,
        doctor:chat.doctor,
        lastMessage: chat.lastMessage,
        timestamp: chat.timestamp,
        unreadCount: chat.unreadCount
      })));
    });
  };

  // mounted permission for calls
useEffect(() => {
  const handleInteraction = () => {
    userInteractedRef.current = true;
    console.log("✅ User interaction detected — audio can now autoplay.");
    window.removeEventListener("click", handleInteraction);
    window.removeEventListener("keydown", handleInteraction);
  };

  window.addEventListener("click", handleInteraction);
  window.addEventListener("keydown", handleInteraction);

  return () => {
    window.removeEventListener("click", handleInteraction);
    window.removeEventListener("keydown", handleInteraction);
  };
}, []);


  
    // Handle incoming call request
    const handleCallRequest = useCallback((data) => {
      setCallRequestData(data);
      setShowCallRequestModal(true);
      // Optional: Play a notification sound
      if (ringingAudioRef.current) {
        ringingAudioRef.current.pause();
        ringingAudioRef.current = null;
      }
      
      const audio = new Audio(ringSound);
      audio.loop = true;
      
      if (userInteractedRef.current) {
        audio.play().catch((err) => {
          console.error("Auto-play failed", err);
        });
      } else {
        console.warn("User hasn't interacted yet. Can't autoplay.");
      }
      
      ringingAudioRef.current = audio;

      
    }, []);

  // Handle call cancelled (initiator cancelled or answered on another device)
  const handleCallCancelled = useCallback((data) => {
    if (ringingAudioRef.current) {
      ringingAudioRef.current.pause();
      ringingAudioRef.current.currentTime = 0;
      ringingAudioRef.current = null;
    }
    setShowCallRequestModal(false);
    setCallRequestData(null);
  }, []);

      // Handle accepting a call
  const handleAcceptCall = useCallback(() => {
    if (!callRequestData) return;
    setShowCallRequestModal(false);
    setShowVideoModal(true);
    setCallStatus("calling");
    // callStartTime = Date.now();
    const socket = getMediaSocket();
    if (socket) {
        socket.emit('accept-call', {
        roomId: callRequestData.roomId,
        // fromId: callRequestData.fromId,
        // toId: profile?.id
        userId: JSON.stringify(profile?.id),
      });
    }
    if (ringingAudioRef.current) {
      ringingAudioRef.current.pause();
      ringingAudioRef.current.currentTime = 0;
      ringingAudioRef.current = null;
    }
    
  }, [callRequestData, profile]);


  // Handle rejecting a call
  const handleRejectCall = useCallback(() => {
    if (!callRequestData) return;
    setShowCallRequestModal(false);
    const socket = getMediaSocket();
    if (socket) {
      socket.emit('call-rejected', {
        roomId: callRequestData.roomId,
        fromId: callRequestData.fromId,
        toId: profile?.id,
        userId:JSON.stringify(profile?.id),
      });

      socket.emit('cancel-call-request', {
				roomId:callRequestData.roomId,
				fromUserId:JSON.stringify(profile?.id),
				toUserId: `${callRequestData?.fromUserId}`,
				token: token,
			});
    }
    if (ringingAudioRef.current) {
      ringingAudioRef.current.pause();
      ringingAudioRef.current.currentTime = 0;
      ringingAudioRef.current = null;
    }
    
    setCallRequestData(null);
  }, [callRequestData, profile]);



  const handleIncomingMessage = useCallback((data) => {
    // Check if message belongs to current active chat
    if (activeUser && 
        (data.fromUserId == activeUser.id || data.fromUserId == JSON.stringify(profile?.id))) {
      const newMessage = {
        message: data.message,
        from: data.fromUserId,
        to: data.toUserId,
        timestamp: data.timestamp || new Date().toISOString()
      };
      
      setMessages(prev => [...prev, newMessage]);
      
      // Scroll to bottom
      setTimeout(() => {
        if (bottomRef.current) {
          bottomRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
      
      // Mark as read if we're the recipient
      if (data.fromUserId === activeUser.id) {
        markMessageAsRead({ 
          fromUserId: activeUser.id, 
          toUserId: JSON.stringify(profile?.id) 
        });
      }
    }
    
    // Always update recent chats when new message arrives
    fetchRecentChats();
  }, [activeUser, profile?.id]);
  

  // Handle user selection
  const handleUserSelect = useCallback((user) => {
    setActiveUser(user);
    setShowChat(true);
    setLoadingMessages(true);
    console.log(user)
    
    if (profile?.id && user?.id) {
      getChatHistoryByPatient(
        { doctorId: user.id, patientId: JSON.stringify(profile?.id),},
        (messages) => {
          const formattedMessages = messages.map(msg => ({
            message: msg.message,
            from: msg.fromUserId,
            to: msg.toUserId,
            timestamp: msg.createdAt
          }));
          setMessages(formattedMessages);
          setLoadingMessages(false);
          
          // Mark messages as read
          markMessageAsRead({ 
            fromUserId: user?.id , 
            toUserId: JSON.stringify(profile?.id) 
          });

          // Scroll to bottom after loading
          setTimeout(() => {
            if (bottomRef.current) {
              bottomRef.current.scrollIntoView({ behavior: 'smooth' });
            }
          }, 100);
        }
      );
    }
  }, [profile]);

  // Handle sending a message
  // const handleSendMessage = (e) => {
  //   e.preventDefault();
    
  //   if (!messageInput.trim() || !activeUser || !profile?.id) return;

  //   const roomId = generateMediaRoomId({ 
  //     patientId: profile.id, 
  //     doctorId: activeUser.id 
  //   });

  //   const newMessage = {
  //     message: messageInput.trim(),
  //     from: profile.id,
  //     to: activeUser.id,
  //     timestamp: new Date().toISOString()
  //   };

  //   // Optimistically update UI
  //   setMessages(prev => [...prev, newMessage]);
  //   setMessageInput("");

  //   // Send via socket
  //   sendMediaMessage({
  //     toUserId: activeUser.id,
  //     roomId,
  //     message: messageInput.trim()
  //   });

  //   // Scroll to bottom
  //   setTimeout(() => {
  //     if (bottomRef.current) {
  //       bottomRef.current.scrollIntoView({ behavior: 'smooth' });
  //     }
  //   }, 100);
  // };

  // Replace your current handleSendMessage with this version
const handleSendMessage = (e) => {
  e.preventDefault();
  
  if (!messageInput.trim() || !activeUser || !profile?.id) return;

  const roomId = generateMediaRoomId({ 
    patientId: profile.id, 
    doctorId: activeUser.id 
  });

  // Optimistically update UI
  const newMessage = {
    message: messageInput.trim(),
    from: profile.id,
    to: activeUser.id,
    timestamp: new Date().toISOString()
  };
  
  setMessages(prev => [...prev, newMessage]);
  setMessageInput("");

  // Send via socket
  sendMediaMessage({
    toUserId: activeUser.id,
    roomId,
    message: messageInput.trim(),
    fromUserId: JSON.stringify(profile?.id),
  });

  // Scroll to bottom
  setTimeout(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, 100);
};

  // Video call handlers
  const startVideoCall = () => {
    setCallStatus("calling");
    setShowVideoModal(true);
    setCallStartTime(Date.now());
    
    // TODO: Implement actual call initiation
  };

  const endVideoCall = () => {
    setCallStatus("ended");
    setTimeout(() => {
      setShowVideoModal(false);
      setCallStartTime(null);
    }, 1000);
  };

  // Format message time
  const formatMessageTime = (timestamp) => {
    const now = moment();
    const msgTime = moment(timestamp);

    if (now.diff(msgTime, 'days') === 0) {
      return msgTime.format('h:mm A');
    } else if (now.diff(msgTime, 'days') === 1) {
      return `Yesterday ${msgTime.format('h:mm A')}`;
    }
    return msgTime.format('MMM DD, h:mm A');
  };

  // Format call duration
  const formatCallDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const uniqueRecentChats = Array.from(
    new Map(recentChats.map(chat => [chat.id, chat])).values()
  );

  return (
    <React.Fragment>
      <Header />
      <div className="">
         {/* Incoming Call Modal */}
 <Modal
          show={showCallRequestModal}
          onHide={handleRejectCall}
          centered
          backdrop="static"
          className="incoming-call-modal"
          // style={{zIndex:'1000'}}
        >
          <Modal.Header>
            <Modal.Title>Incoming Call</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="text-center">
              <h5>{callRequestData?.callerName || 'Unknown Caller'}</h5>
              <p>Is calling you...</p>
              <div className="d-flex justify-content-center gap-3 mt-4">
                <Button variant="success" onClick={handleAcceptCall}>
                  Accept
                </Button>
                <Button variant="danger" onClick={handleRejectCall}>
                  Reject
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>


        {/* Video Call Modal */}
        <Modal 
          show={showVideoModal} 
          onHide={endVideoCall}
          centered
          size="xl"  // Changed to xl for better video display
          fullscreen={isFullScreen}  // Add fullscreen support
          backdrop="static"
          className="video-call-modal p-0"
        >
          <Modal.Body className="p-0">
            <CallScreen
                callConfig={{
                name: callRequestData?.callerName || 'patient',
                roomId: callRequestData?.roomId,
                patientId: JSON.stringify(profile?.id),
                peerId: JSON.stringify(callRequestData?.fromUserId),
                onEndCall: endVideoCall,
                audioOnly: callRequestData?.audioOnly,
                callerAvatar: callRequestData?.callerAvatar
              }}

            //   name={callRequestData?.callerName || 'patient'}
            //    roomId={callRequestData?.roomId}
            //    setIsCallOpen= {setShowVideoModal}
            //   doctorId= {callRequestData?.fromUserId
            //   }
            />
          </Modal.Body>
        </Modal>

       
      </div>
    </React.Fragment>
  );
};

// CustomToggle component
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <Link
    to=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    className="header-link"
  >
    {children}
  </Link>
));

export default ChatGlobal;


